import { Component, OnInit } from '@angular/core';

import { ListResponse } from '../../../../../models/list-response';
import {
  getMembershipIntervalDisplay,
  getMembershipStatusDisplay,
  getMembershipDurationDisplay,
  getMembershipPurchaseTypeDisplay,
  Membership,
} from '../../../../../models/membership';
import {
  EntryPass,
  getEntryPassStatusDisplay
} from '../../../../../models/entry-pass';
import { AccountService } from '../../../../../services/account/account.service';
import { MembershipService } from '../../../../../services/membership/membership.service';
import { EntryPassService } from '../../../../../services/entry-pass/entry-pass.service';
import { OrganizationConfigService } from '../../../../../services/organization-config/organization-config.service';
import { EntryPassStatus } from '../../../../../models/entry-pass-enums';
import { MembershipPurchaseType, MembershipStatus } from '../../../../../models/membership-enums';

@Component({
  selector: 'app-memberships',
  templateUrl: './memberships.component.html',
  styleUrls: ['./memberships.component.css']
})
export class MembershipsComponent implements OnInit {

  public membershipList: ListResponse<Membership>;
  public entryPassList: ListResponse<EntryPass>;

  public loadingMemberships = false;
  public loadingEntryPasses = false;

  public serverError: number = null;

  // Make browser history available to the template.
  public history: History;

  // Create instance references to lookup functions and enums so they may be
  // called in the template.
  public readonly MembershipStatus = MembershipStatus;
  public readonly EntryPassStatus = EntryPassStatus;
  public readonly MembershipPurchaseType = MembershipPurchaseType;
  public readonly getMembershipIntervalDisplay = getMembershipIntervalDisplay;
  public readonly getMembershipDurationDisplay = getMembershipDurationDisplay;
  public readonly getMembershipStatusDisplay = getMembershipStatusDisplay;
  public readonly getEntryPassStatusDisplay = getEntryPassStatusDisplay;
  public readonly getMembershipPurchaseTypeDisplay = getMembershipPurchaseTypeDisplay;

  constructor(
    public accountService: AccountService,
    public orgConfigService: OrganizationConfigService,
    private membershipService: MembershipService,
    private entryPassService: EntryPassService,
    private orgService: OrganizationConfigService,
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().can_manage_members) {
      return;
    }

    // Make browser history available to the template.
    this.history = history;

    this.loadMemberships();
    this.loadEntryPasses();
  }

  public loadMemberships() {
    this.loadingMemberships = true;

    this.membershipService
      .getMemberships(1, 100)
      .then(response => {
        this.membershipList = response;
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingMemberships = false; });
  }

  public loadEntryPasses() {
    this.loadingEntryPasses = true;

    this.entryPassService
      .getEntryPasses(1, 100)
      .then(response => { this.entryPassList = response; })
      .catch(reason => {
        if (reason.status === 403 ) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingEntryPasses = false; });
  }

  /**
   * Whether a non-zero number of membership results have been loaded.
   */
  public membershipResultsPresent(): boolean {
    return (
      this.membershipList &&
      this.membershipList.results &&
      (this.membershipList.results.length > 0)
    );
  }

  /**
   * Whether a non-zero number of entry passes have been loaded.
   */
  public entryPassResultsPresent(): boolean {
    return (
      this.entryPassList &&
      this.entryPassList.results &&
      (this.entryPassList.results.length > 0)
    );
  }

  public climberAppMembershipDetailsUrl(membership: Membership) {
    const baseUrl = this.orgService.getOrganizationConfig().climber_app_base_url;
    const productId = membership.id.toString();
    return baseUrl + 'membership/choose-members/' + productId + '/';
  }

  public climberAppEntryPassDetailsUrl(entryPass: EntryPass) {
    const baseUrl = this.orgService.getOrganizationConfig().climber_app_base_url;
    const productId = entryPass.id.toString();
    return baseUrl + 'pass/purchase-init/' + productId + '/';
  }
}
